import React from 'react';
import { Button, Spinner } from 'reactstrap';
import classnames from 'classnames';

export default ({ children, loading, block, ...rest }) => {
  // Preserve existing behavior (disable while loading) but also allow callers to disable.
  const isDisabled = !!loading || !!rest.disabled;

  return (
    <Button {...rest} disabled={isDisabled} block={block}>
      {!(block && !loading) && (
        <Spinner
          // Reactstrap renders "Loading..." as default children (sr-only).
          // In this project, sr-only style might not hide it, so we pass empty children.
          children=""
          className={classnames({
            'position-relative': true,
            'button-style': !block,
            visible: loading,
            invisible: !loading,
          })}
          style={{
            display: !!loading ? undefined : 'none',
          }}
          size="sm"
        />
      )}
      {!(block && loading) && (
        <span
          className={classnames({
            invisible: loading,
            visible: !loading,
            'span-style': !block,
          })}
        >
          {children}
        </span>
      )}
    </Button>
  );
};
